export default "__VITE_ASSET__CdkNAcM4__"